import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sports: [],
  bookings: [],
  timeSlots: [],
  offPeakRates: [],
  clubAccounts: [],
  selectedDate: new Date().toISOString(),
  selectedSport: "",
  selectedCourt: "",
  selectedDuration: null,
  selectedTime: "",
  courtCharges: 0,
  originalCourtCharges: 0, // Add original court charges
  clubDiscount: 0, // Add club discount percentage
  discount: 0,
  selectedPaymentTypeId: null,
  promoCode: "",
  promoCodeError: "",
  promoCodeDetails: null,
  subTotal: 0,
  advancePayment: 0,
  payOnClub: 0,
  partialPaymentPercentage: 0,
  bookingPayload: null,
  termsAndConditions: [],
  isBookingFlow: false,
  bankDiscounts: [],
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setSports: (state, action) => {
      state.sports = action.payload;
    },
    setClubAccounts: (state, action) => {
      state.clubAccounts = action.payload;
    },
    setBookings: (state, action) => {
      state.bookings = action.payload;
    },
    setTimeSlots: (state, action) => {
      state.timeSlots = action.payload;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setSelectedSport: (state, action) => {
      state.selectedSport = action.payload;
    },
    setSelectedCourt: (state, action) => {
      state.selectedCourt = action.payload;
    },
    setSelectedDuration: (state, action) => {
      state.selectedDuration = action.payload;
    },
    setSelectedTime: (state, action) => {
      state.selectedTime = action.payload;
    },
    setOffPeakRates: (state, action) => {
      state.offPeakRates = action.payload;
    },
    setClubDiscount: (state, action) => {
      state.clubDiscount = action.payload;
    },
    setOriginalCourtCharges: (state, action) => {
      state.originalCourtCharges = action.payload;
    },
    setCourtCharges: (state, action) => {
      state.courtCharges = action.payload;
      state.subTotal = state.courtCharges - state.discount;
    },
    setPromoCode: (state, action) => {
      state.promoCode = action.payload;
    },
    setPromoCodeError: (state, action) => {
      state.promoCodeError = action.payload;
    },
    setPromoCodeDetails: (state, action) => {
      state.promoCodeDetails = action.payload;
    },
    setDiscount: (state, action) => {
      state.discount = action.payload;
      state.subTotal = state.courtCharges - state.discount;
    },
    setSelectedPaymentTypeId: (state, action) => {
      state.selectedPaymentTypeId = action.payload;
    },
    setAdvancePayment: (state, action) => {
      state.advancePayment = action.payload;
    },
    setPayOnClub: (state, action) => {
      state.payOnClub = action.payload;
    },
    setPartialPaymentPercentage: (state, action) => {
      state.partialPaymentPercentage = action.payload;
    },
    setBookingPayload: (state, action) => {
      state.bookingPayload = action.payload;
    },
    setTermsAndConditions: (state, action) => {
      state.termsAndConditions = action.payload;
    },
    setIsBookingFlow: (state, action) => {
      state.isBookingFlow = action.payload;
    },
    setBankDiscounts: (state, action) => {
      state.bankDiscounts = action.payload;
    },
  },
});

export const {
  setSports,
  setBookings,
  setTimeSlots,
  setSelectedDate,
  setSelectedSport,
  setSelectedCourt,
  setSelectedDuration,
  setSelectedTime,
  setOffPeakRates,
  setClubAccounts,
  setClubDiscount,
  setOriginalCourtCharges,
  setCourtCharges,
  setPromoCode,
  setPromoCodeError,
  setPromoCodeDetails,
  setDiscount,
  setSelectedPaymentTypeId,
  setAdvancePayment,
  setPayOnClub,
  setPartialPaymentPercentage,
  setBookingPayload,
  setTermsAndConditions,
  setIsBookingFlow,
  setBankDiscounts,
} = bookingSlice.actions;

export default bookingSlice.reducer;

export const getSports = (state) => state.booking.sports;
export const getAvailableTimeSlots = (state) => state.booking.timeSlots;
export const getSelectedDate = (state) => state.booking.selectedDate;
export const getSelectedSport = (state) => state.booking.selectedSport;
export const getSelectedCourt = (state) => state.booking.selectedCourt;
export const getSelectedDuration = (state) => state.booking.selectedDuration;
export const getSelectedTime = (state) => state.booking.selectedTime;
export const getOffPeakRates = (state) => state.booking.offPeakRates;
export const getClubDiscount = (state) => state.booking.clubDiscount;
export const getOriginalCourtCharges = (state) =>
  state.booking.originalCourtCharges;
export const getCourtCharges = (state) => state.booking.courtCharges;
export const getDiscount = (state) => state.booking.discount;
export const getClubAccounts = (state) => state.booking.clubAccounts;
export const getSelectedPaymentTypeId = (state) =>
  state.booking.selectedPaymentTypeId;
export const getPromoCode = (state) => state.booking.promoCode;
export const getPromoCodeError = (state) => state.booking.promoCodeError;
export const getPromoCodeDetails = (state) => state.booking.promoCodeDetails;
export const getSubTotal = (state) => state.booking.subTotal;
export const getAdvancePayment = (state) => state.booking.advancePayment;
export const getPayOnClub = (state) => state.booking.payOnClub;
export const getPartialPaymentPercentage = (state) =>
  state.booking.partialPaymentPercentage;
export const getBookingPayload = (state) => state.booking.bookingPayload;
export const getTermsAndConditions = (state) =>
  state.booking.termsAndConditions;
export const getIsBookingFlow = (state) => state.booking.isBookingFlow;
export const getBankDiscounts = (state) => state.booking.bankDiscounts;